import type { AgentToolConfigArg } from '@takeshape/schema';
import { type ActionType, createAction } from 'typesafe-actions';

type SetToolArgDefaultsPayload = {
  args: AgentToolConfigArg[];
};

type SetToolArgDefaultsMeta = {
  path: string[];
};

export const AI_SET_TOOL_ARG_DEFAULTS = 'ai/SET_TOOL_ARG_DEFAULTS';
export const setAiToolArgDefaults = createAction(AI_SET_TOOL_ARG_DEFAULTS)<
  SetToolArgDefaultsPayload,
  SetToolArgDefaultsMeta
>();
export type SetAiToolArgDefaultsCreator = typeof setAiToolArgDefaults;
export type SetAiToolArgDefaultsAction = ActionType<typeof setAiToolArgDefaults>;

export const AGENTS_SET_TOOL_ARG_DEFAULTS = 'agents/SET_TOOL_ARG_DEFAULTS';
export const setAgentsToolArgDefaults = createAction(AGENTS_SET_TOOL_ARG_DEFAULTS)<
  SetToolArgDefaultsPayload,
  SetToolArgDefaultsMeta
>();
export type SetAgentsToolArgDefaultsCreator = typeof setAgentsToolArgDefaults;
export type SetAgentsToolArgDefaultsAction = ActionType<SetAgentsToolArgDefaultsCreator>;
